var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "70 95 102.46 138.6",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.27,146.13c0-30.4,21.23-50.29,50.49-50.29,30,0,51.05,21,51.05,50.1s-21.22,49.34-48.95,49.34c-18,0-32.7-8.42-39.78-22.76v60.62H70.27Zm88.54-.57c0-21.8-15.3-37.86-37.86-37.86-22.76,0-37.87,16.06-37.87,37.86S98.19,183.42,121,183.42C143.51,183.42,158.81,167.36,158.81,145.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.f37a7a4491f37008a9e33862eab4aea1.svg";
export { ForwardRef as ReactComponent };